import { IBreadcrumb, BreadcrumbElements } from "./interface";
import { Link } from "react-router-dom";
import "./breadcrumb.scss";

export const Breadcrumb = ({ routes }: IBreadcrumb) => {
  return (
    <div data-testid="breadcrumb" className="breadcrumb-container">
      {routes.map((breadcrumb: BreadcrumbElements, index: number) => {
        const lastRoute = routes.length - 1;
        return (
          <div key={breadcrumb.route}>
            {index > 0 && <span className="breadcrumb">/</span>}
            {index === lastRoute || breadcrumb?.readOnly ? (
              <label className="breadcrumb breadcrumb-current-link">
                {breadcrumb.label}
              </label>
            ) : (
              <Link
                to={breadcrumb.route}
                className={`breadcrumb-link ${
                  breadcrumb?.disabled
                    ? "breadcrumb-disabled"
                    : "breadcrumb-active"
                }`}
              >
                {breadcrumb.label}
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
};
